import space from '../namespace';
import defaultState, { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.detail]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  >,
): IState => {
  const { type, namespace = space.detail, payload } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.RESET_PAGE_STATE]: {
      const { namespace: resetNameSpace = space.home, resetKeys = [] } = payload || {};
      const resetValues = resetKeys.reduce((prev, cur) => {
        const defaultValue = defaultState()[resetNameSpace] as any;
        return defaultValue
          ? { ...prev, [cur]: defaultValue[cur] }
          : { ...prev };
      }, {});
      return {
        ...state,
        [resetNameSpace]: {
          ...state[resetNameSpace],
          ...resetValues,
        },
      };
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_EMOJIES]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          emojies: payload,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_DELETEREASONS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          deleteReasons: payload,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.PUBLISH_SUCCESS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          publishSuccess: true,
          ext: payload,
        }
      }
    }

    case actionTypes[namespace][ActionTypeValues.UPDATE_TOTALREPLYS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          totalReplys: payload,
        }
      }
    }

    default:
      return state;
  }
};

export default reducer;
